import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'
import {useIssueCommentsActions, usePullRequestBasePath} from '../stores/selectors'
import type {IssueComment} from '../page-data/payloads/issue-comments'

export type CreateTimelineCommentMutationData =
  | {text: string; closePullRequest?: never; reopenPullRequest?: never}
  | {text: string; closePullRequest: true; reopenPullRequest?: never}
  | {text: string; closePullRequest?: never; reopenPullRequest: true}
type MutationResponse = {
  message: string
  commentId: number
  issueComment: IssueComment
}

export function useCreatePullRequestTimelineCommentMutation() {
  const basePath = usePullRequestBasePath()
  const apiUrl = `${basePath}/page_data/${PageData.submitPullRequestTimelineComment}`
  const {addIssueComment} = useIssueCommentsActions()
  // TODO: add the store calls that we will eventually need to update the UI
  // with the information received about the comment

  return useMutation({
    mutationFn: async (data: CreateTimelineCommentMutationData) => {
      const result = await reactFetchJSON(`${apiUrl}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: data,
      })

      const json = await parseJSONWithBetterErrors(result)
      throwErrorsIfBadResponse(result, json)
      return json
    },
    onSuccess: (data: MutationResponse, _inputs: CreateTimelineCommentMutationData) => {
      addIssueComment(data.issueComment)
    },
  })
}
